import type { FC } from "react";

import { WorkflowLaunchpad } from "./WorkflowLaunchpad";

/**
 * The center pane's Case Automations tab. The center body is a flex column,
 * so this pane is the scrollport and the launchpad starts at the top.
 */
export const WorkflowsPane: FC = () => (
  <div className="flex h-full min-h-0 flex-1 flex-col items-stretch justify-start overflow-y-auto bg-surface">
    <WorkflowLaunchpad className="mx-auto w-full max-w-5xl shrink-0 px-6 py-6" />
  </div>
);
